import React from "react";

// Cihazlar/Firmalar sayfalarındaki kart diliyle aynı palet:
// beyaz kart + gray-200 border + kategoriye özel pastel *-50 ikon çipi.
const COLOR_MAP = {
  blue: { iconBg: "bg-blue-50", iconBgHover: "group-hover:bg-blue-100", iconText: "text-blue-600", border: "border-blue-100" },
  emerald: { iconBg: "bg-emerald-50", iconBgHover: "group-hover:bg-emerald-100", iconText: "text-emerald-600", border: "border-emerald-100" },
  amber: { iconBg: "bg-amber-50", iconBgHover: "group-hover:bg-amber-100", iconText: "text-amber-600", border: "border-amber-100" },
  indigo: { iconBg: "bg-indigo-50", iconBgHover: "group-hover:bg-indigo-100", iconText: "text-indigo-600", border: "border-indigo-100" },
  purple: { iconBg: "bg-purple-50", iconBgHover: "group-hover:bg-purple-100", iconText: "text-purple-600", border: "border-purple-100" },
  red: { iconBg: "bg-red-50", iconBgHover: "group-hover:bg-red-100", iconText: "text-red-600", border: "border-red-100" },
  gray: { iconBg: "bg-gray-50", iconBgHover: "group-hover:bg-gray-100", iconText: "text-gray-600", border: "border-gray-100" },
};

export default function StatCard({ title, count, icon, onClick, color = "blue" }) {
  const c = COLOR_MAP[color] || COLOR_MAP.blue;

  return (
    <div
      onClick={onClick}
      className="relative rounded-2xl shadow-sm p-3 sm:p-4 transition-all duration-300 hover:shadow-md hover:-translate-y-1 cursor-pointer flex flex-col items-center justify-center text-center bg-white border border-gray-200 hover:border-gray-300 group"
    >
      <div className={`mb-2 sm:mb-3 p-2 sm:p-3 ${c.iconBg} border ${c.border} rounded-xl ${c.iconBgHover} transition-colors duration-300`}>
        <div className={`${c.iconText} text-lg sm:text-2xl`}>{icon}</div>
      </div>

      <p className="text-gray-900 font-bold text-xl sm:text-3xl">
        {count}
      </p>

      <p className="text-gray-600 text-xs sm:text-sm font-medium mt-1 sm:mt-2 group-hover:text-gray-700 transition-colors duration-300">
        {title}
      </p>
    </div>
  );
}
